import React from 'react';
import { connect } from 'react-redux';
import DspDocsComponent from '../components/DspDocsComponent';

const mapStateToProps = state =>
    ( {
    } );

const mapDispatchToProps = dispatch =>
    ( {
    } );

const DspDocsContainer = props => <DspDocsComponent {...props}/>;

export default connect(
    mapStateToProps,
    mapDispatchToProps
)( DspDocsContainer );
